import React, { Component } from 'react';
import _ from 'lodash';
import Joi from 'joi-browser';
import { withRouter } from 'react-router-dom';

import {
  Form,
  createFormEventManager,
  SwitchForm,
} from '../components/FormBase';
import {
  FormList,
  FormListItem,
  FormElement,
} from '../components/CommonFormComponents';
import * as FormEle from '../components/UserProfileFormElements';
import * as UserFormElements from '../components/UserFormElements';
import fetchMg from '../utilities/fetchManager';
import {
  INTEGRATE_USER_CHANGE_EMAIL_CONFIRM_MESSAGE,
  INTEGRATE_USER_COMMON_ERROR_MESSAGE,
  USER_ROLES,
} from '../utilities/constants';
import {
  // スキーム
  UserProfileScheme,
  UserProfileSchemeForeman,
  UserProfileSchemeWithPassword,
  UserProfileSchemeForemanWithPassword,
  // 必須分数用
  UserProfileRequired,
  UserProfileRequiredForeman,
  PasswordRequired,
} from '../utilities/JoiSchemes';
import {
  isPartnerCompanyRoleId,
  isPrimaryCompanyRoleId,
  isTargetRoleId,
  isForemanRoleId,
} from '../utilities/roleUtility';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { UserService } from '../services/Users';
import { LoginUserGroupsService } from '../services/LoginUserGroups';
import { changeImageDataToBlob } from '../utilities/imageUtility';
import { DialogSuccessError } from '../components/modals/DialogSuccessError';
import { Modal } from '../components/Modal';
import { messageUtility } from '../utilities/messageUtility';
import { runExtendJoi } from '../utilities/formUtil';
import { Confirmation } from '../components/modals/common/';
import AuthProvider from '../utilities/authProvider';
import { formatTel } from '../utilities/stringUtil';
import { MasterPageHeader } from '../components/PageHeader';
import { validatePasswordPolicy } from '../utilities/commonValidation';
import { PasswordPolicyService } from '../services/PasswordPolicyService';
import { UsersApi } from '../services/users/UsersApi';
import { HEAD_OFFICE_OPTION } from '../components/PartnerCompanyBranchDropdown';
import { ConfirmIntegrateUserDialog } from '../components/modals/ConfirmIntegrateUserDialog';
import { ConfirmExistedEmailDialog } from '../components/modals/ConfirmExistedEmailDialog';
import { ConfirmChangeIntegratedEmailDialog } from '../components/modals/ConfirmChangeIntegratedEmailDialog';
import { IntegrateError } from '../components/modals/IntegrateError';
import Information from '../components/modals/common/Information';
import { LogoutUserIntegrateModal } from '../components/modals/LogoutUserIntegrateModal';

/**
 * @description アカウント " 詳細 " 画面（パスワード強制変更）
 */
class InvitedUserProfileForm extends Component {
  constructor(props) {
    super(props);

    this.roleId = LocalStorageService.getRoleId();
    this.userId = LocalStorageService.getUserId();
    this.companyId = SessionStorageService.getCompanyId();

    let scheme = null;
    let required = null;
    // スキーマ設定処理
    if (isTargetRoleId([USER_ROLES.foreman], this.roleId)) {
      // 職長
      scheme = _.cloneDeep(UserProfileSchemeForemanWithPassword);
      required = _.cloneDeep(UserProfileRequiredForeman);
      // パスワードの必須付き(mergeは破壊的)
      _.merge(required, PasswordRequired);
    } else {
      scheme = _.cloneDeep(UserProfileSchemeWithPassword);
      required = _.cloneDeep(UserProfileRequired);
      // パスワードの必須付き(mergeは破壊的)
      _.merge(required, PasswordRequired);
    }

    this.state = {
      validate: {},
      params: {}, // フォームの値を保持
      scheme, // スキーマ
      required, // 必須項目数
      isSamlUser: 'false', // SAML認証ユーザーフラグ,
      privatePasswordPolicy: {},
      isManagerPermission: false,
      joiningFlag: false,
      visibleConfirmation: false,
      visibleEmailExistedConfirmation: false,
      visibleIntegrateConfirmation: false,
      visibleIntegrateError: false,
      reasonIntegrateError: '',
      integrateUsers: [],
      visiblePopupCommonError: false,
      visibleLogoutUser: false,
      visibleChangeIntegratedEmail: false,
      updateMsg: '',
      updateMsgDetail: '',
    };
    // Form で使う EventManager を作成
    this.FormEventMg = createFormEventManager();
    this.checkingIntegrate = false;
    this.runningIntegrate = false;
    this.tempFormSubmit = null;
    // 連打防止_BLDE_V2-46943 【CS135_アカウント詳細・編集（パスワード強制変更）】「更新」ボタンを連続押下すると、「エラーが発生しました。」ダイアログが表示される(パスワード変更は成功している)
    this.isSubmittingFlag = false;
  }

  async componentDidMount() {
    await this.onLoad();
    this.getPasswordPolicy();
    this.setPermission();
  }

  setPartnerCompanyBranchInitValue = () => {
    if (this.state.joiningFlag && this.state.isManagerPermission) {
      this.setState(prevState => ({
        required: {
          ...prevState.required,
          partner_company_branch: true,
        },
      }));
    }
  };

  /**
   * @description ダイアログ開閉設定
   * @param {boolean} isShow ダイアログ on/off
   */
  handleVisibleDialog = isShow => {
    this.setState({ visibleConfirmation: isShow });
  };

  toggleDialog = (key, value, callback) => {
    this.setState({ [key]: value }, callback);
  };

  onLoad = async () => {
    const data = await fetchMg.GetAjax(
      `/api/private/user_profiles/${this.userId}`
    );
    if (data.result) {
      const params = data.data.entities.user_profile;
      params.partner_company_branch = data.data.entities.partner_company_branch;
      params.user_role_code = data.data.entities.role_code;
      // 本社管理者はcompany_branchが空配列
      params.company_branch_id =
        !_.isUndefined(data.data.entities.company_branch) &&
        _.size(data.data.entities.company_branch) !== 0
          ? data.data.entities.company_branch[0].id
          : null;
      params.company = data.data.entities.company[0] || {};
      params.session = data.data.entities.session || {};
      params.image = data.data.entities.image || {};
      // company_branch(プルダウンのため)
      const companyBranch = data.data.entities.company_branch[0];

      // SAML認証ユーザー処理
      const isSamlUser = data.data.entities.is_saml_user;
      if (isSamlUser === 'true') {
        let scheme, required;
        if (isTargetRoleId([USER_ROLES.foreman], this.roleId)) {
          scheme = _.cloneDeep(UserProfileSchemeForeman);
          required = _.cloneDeep(UserProfileRequiredForeman);
        } else {
          scheme = _.cloneDeep(UserProfileScheme);
          required = _.cloneDeep(UserProfileRequired);
        }
        this.setState({ scheme, required });
      }

      this.setState({
        params,
        companyBranch,
        isSamlUser,
        joiningFlag: !!data.data.entities.company[0].joining_flag,
      });
    }
  };

  getPasswordPolicy = async () => {
    const roleId = parseInt(LocalStorageService.getRoleId());

    PasswordPolicyService.getPasswordPolicy(roleId).then(({ data }) => {
      this.setState(
        {
          privatePasswordPolicy: data,
        },
        () => {
          this.setSchemaPasswordPolicy();
        }
      );
    });
  };

  setSchemaPasswordPolicy = () => {
    const scheme = _.cloneDeep(this.state.scheme).append({
      password: Joi.string()
        .required()
        .max(0)
        .error(err =>
          validatePasswordPolicy(err, this.state.privatePasswordPolicy)
        ),
      password_confirmation: Joi.string()
        .required()
        .max(0)
        .error(err =>
          validatePasswordPolicy(err, this.state.privatePasswordPolicy)
        ),
    });

    this.setState({
      scheme,
    });
  };

  setPermission = () => {
    UsersApi.fetchCompanyUserPermissions(this.companyId, {
      buildee_manager_flg: 1,
    }).then(({ result, data }) => {
      let isManagerPermission = false;

      if (result && data.total > 0) {
        const { company_user_permissions: permissions } = data.entities;
        for (let permission of permissions) {
          if (permission.user_id === Number(this.userId)) {
            isManagerPermission = true;
            break;
          }
        }
      }

      this.setState(
        { isManagerPermission },
        this.setPartnerCompanyBranchInitValue
      );
    });
  };

  /**
   * 更新ボタン押下
   *
   * @param {object} params
   * @memberof InvitedUserProfileForm
   */
  submitDefault = params => {
    const currentLoginId = LocalStorageService.getItem('login_id');
    if (currentLoginId !== params.login_id && currentLoginId !== params.email) {
      if (this.state.params.integrated) {
        this.toggleDialog(
          'visibleChangeIntegratedEmail',
          true,
          this.getGroupIntegratedUsers
        );
        return;
      }

      // 警告メッセージダイアログを開く
      this.handleVisibleDialog(true);
      // 警告メッセージダイアログのコールバック
      this.setState({
        confirm: () => {
          // 閉じる
          this.handleVisibleDialog(false);
          // そのままsubmit実行後、正常の場合ログアウト
          this.runSubmit(params, true);
        },
      });
      return;
    }

    // そのままsubmit実行
    this.runSubmit(params);
  };

  submit = async params => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    params.tel = formatTel(params.tel);
    const result = runExtendJoi(this.state.scheme, params);

    // 職長かつemailが更新パラメータに含まれない場合、nullで更新
    if (isForemanRoleId(this.roleId) && !_.has(params, 'email')) {
      params['email'] = null;
    }

    if (!result.status) {
      // エラーメッセージを表示
      this.setState({ validate: result.messages });
      this.isSubmittingFlag = false;
      return;
    }

    this.tempFormSubmit = params;

    const emailExist = await this.checkEmailDuplicateApi(params);
    this.isSubmittingFlag = false;
    if (!emailExist) {
      this.submitDefault(params);
      return;
    }

    this.toggleDialog('visibleEmailExistedConfirmation', true);
  };

  getGroupIntegratedUsers = () => {
    LoginUserGroupsService.list().then(({ result, data }) => {
      if (result && this.state.visibleChangeIntegratedEmail) {
        this.setState({
          integrateUsers: _.get(data, 'entities.users') || [],
        });
      }
    });
  };

  confirmChangeIntegratedEmail = () => {
    this.toggleDialog('visibleChangeIntegratedEmail', false);
    this.runSubmit(this.tempFormSubmit, true);
  };

  confirmExistedEmailIgnoreIntegrate = () => {
    this.toggleDialog('visibleEmailExistedConfirmation', false);
    this.submitDefault(this.tempFormSubmit);
  };

  confirmExistedEmailIntegrate = () => {
    this.submitIntegrate(this.tempFormSubmit);
  };

  integrateErrorConfirm = () => {
    this.toggleDialog('visibleIntegrateError', false);
    this.submitDefault(this.tempFormSubmit);
  };

  submitIntegrate = async params => {
    if (this.checkingIntegrate) {
      return;
    }
    this.checkingIntegrate = true;

    const res = await this.checkIntegrateApi(params);
    this.checkingIntegrate = false;
    this.toggleDialog('visibleEmailExistedConfirmation', false);
    if (res && res.result) {
      this.setState({
        visibleIntegrateConfirmation: true,
        integrateUsers: _.get(res, 'data.entities.users'),
      });
    } else {
      this.setState({
        visibleIntegrateError: true,
        reasonIntegrateError: _.get(res, 'data.message', ''),
      });
    }
  };

  integrateConfirm = () => this.runIntegrate(this.tempFormSubmit);

  /**
   * 保存処理
   * @param {object} params
   * @param {boolean} logoutFlag // ログアウト
   */
  runSubmit = (params, logoutFlag = false) => {

    // 連打防止_BLDE_V2-46943 【CS135_アカウント詳細・編集（パスワード強制変更）】「更新」ボタンを連続押下すると、「エラーが発生しました。」ダイアログが表示される(パスワード変更は成功している)
    if (this.isSubmittingFlag) {
      return;
    }

    const dataSubmit = this.createSubmitData(params);
    if (!dataSubmit) {
      return;
    }
    // 連打防止フラグ
    this.isSubmittingFlag = true;

    // エラーメッセージ非表示
    this.setState({ validate: {} });
    UserService.update(this.userId, dataSubmit)
      .then(response => {
        if (response.status >= 400) {
          throw new Error(response.data.message);
        }
        // レスポンスが正常だった時はisEmpty(パスワード未更新フラグ)をsessoinStorageから消す
        SessionStorageService.removeItem('isEmpty');
        // モーダルの表示(更新しました)
        this.setState({
          showModal: true,
          updateSuccess: true,
          updateMsg: messageUtility.getMessage('I-000-003'),
          updateMsgDetail: '',
        });
        if (logoutFlag) {
          // ログアウト
          this.logout();
        }
      })
      .catch(error => {
        let errorMessage = '';
        // errorにちゃんと入ってた場合
        if (error && error.message) {
          errorMessage = error.message;
        } else {
          // errorに入ってないときは安全にデフォルトのエラーメッセージ
          errorMessage = messageUtility.getMessage('E-000-001');
        }
        // モーダルの表示(通信エラー)
        this.setState({
          showModal: true,
          updateSuccess: false,
          updateMsg: messageUtility.getMessage('E-001-402'),
          updateMsgDetail: errorMessage,
        });
      })
      .finally(() => {
        this.isSubmittingFlag = false;
      });
  };

  runIntegrate = params => {
    const dataSubmit = this.createSubmitData(params);
    if (!dataSubmit || this.runningIntegrate) {
      return;
    }
    this.runningIntegrate = true;

    UserService.updateIntegrate(this.userId, dataSubmit)
      .then(response => {
        if (response.result) {
          this.setState({
            validate: {},
            visibleIntegrateConfirmation: false,
            visibleLogoutUser: true,
          });
        } else {
          throw new Error(_.get(response, 'data.message', ''));
        }
      })
      .catch(() => {
        this.setState({
          visibleIntegrateConfirmation: false,
          visiblePopupCommonError: true,
        });
      })
      .finally(() => {
        this.runningIntegrate = false;
      });
  };

  getParamsApiCheck = params => ({
    email: params.email,
    user_role_code: this.roleId,
    company_id: this.companyId,
    company_branch_id: params.company_branch_id,
    update_user_id: this.userId,
  });

  checkIntegrateApi = async params => {
    return await LoginUserGroupsService.checkIntegrate(
      this.getParamsApiCheck(params)
    );
  };

  checkEmailDuplicateApi = async params => {
    const res = await LoginUserGroupsService.checkDuplicateEmail(
      this.getParamsApiCheck(params)
    );
    return res.result;
  };

  createSubmitData = params => {
    if (_.has(params, 'user_image')) {
      if (
        typeof params.user_image === 'object' &&
        _.isEmpty(params.user_image)
      ) {
        params.user_image = '';
      }
      if (
        params.user_image.match(/image\/(.+);/) || // アップロードファイルチェック
        params.user_image === '' // ファイル削除の場合
      ) {
        // 画像
        try {
          if (params.user_image !== '') {
            params.user_image = changeImageDataToBlob(params.user_image);
          }
        } catch (e) {
          const errorMessage = messageUtility.getMessage('E-000-003');
          // モーダルの表示(画像エラー)
          this.setState({
            showModal: true,
            updateSuccess: false,
            updateMsg: messageUtility.getMessage('E-001-402'),
            updateMsgDetail: errorMessage,
          });
          return;
        }
      } else {
        delete params.user_image;
      }
    }

    return params;
  };

  logout = () => {
    LocalStorageService.setItem('is_logout', '1');

    // ログアウト処理
    AuthProvider.instance.logout();
  };

  /**
   * 各バリデーションエラーメッセージを出す
   *
   * @param {boolean}}} result
   * @memberof InvitedUserProfileForm
   */
  validateMessageUpdate = ({ messages }) => {
    this.setState({ validate: messages });
  };

  handleSelectPartnerCompanyBranch = partnerCompanyBranchId => {
    const { params } = this.state;
    this.setState({
      params: {
        ...params,
        partner_company_branch: {
          id: partnerCompanyBranchId,
        },
      },
    });
  };

  render() {
    const {
      validate,
      params,
      companyBranch,
      isSamlUser,
      scheme,
      required,
      isManagerPermission,
      joiningFlag,
    } = this.state;
    const imageURL = _.get(params, 'image.image_url', '');

    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <div className='contruction-slide-view__view'>
          <FormTopHeader
            title={this.props.title}
            {...this.props}
            logoutButton={
              <button
                className='btn--negative PageHeader__logout--button'
                onClick={this.logout}
              >
                ログアウト
              </button>
            }
          />
          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <FormViewMenu
                  scheme={scheme}
                  EventMg={this.FormEventMg}
                  required={required}
                  validate={validate}
                  validateMessageUpdate={this.validateMessageUpdate}
                />
                <div className='contruction-detail-view__bar' />
                {/* ここからフォーム */}
                <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix'>
                  <FormList>
                    <Form EventMg={this.FormEventMg} submit={this.submit}>
                      {/* ログインユーザーが協力会社の場合のみ表示される項目 */}
                      <SwitchForm show={isPartnerCompanyRoleId(this.roleId)}>
                        {/* 元請会社／協力会社(ただのドロップダウン) */}
                        <UserFormElements.CompanyBaseDropdown
                          companyBranch={companyBranch}
                          disabled={true}
                        />
                      </SwitchForm>
                      {/* ログインユーザーが元請ユーザーの場合のみ表示される項目。 */}
                      <SwitchForm show={isPrimaryCompanyRoleId(this.roleId)}>
                        <FormEle.AffCompany
                          defaultValue={_.get(params, 'company.name')}
                        />
                      </SwitchForm>
                      {/* ログインユーザーが職長の場合のみ表示される項目。 */}
                      <SwitchForm show={this.roleId === USER_ROLES.foreman.id}>
                        <FormEle.AffCompany
                          defaultValue={_.get(params, 'company.name')}
                        />
                      </SwitchForm>
                      {/* 支店（パスワード強制変更では参照のみ） */}
                      {joiningFlag && (
                        <FormEle.PartnerCompanyBranch
                          selectedCompanyId={this.companyId}
                          onSelect={this.handleSelectPartnerCompanyBranch}
                          defaultValue={params.partner_company_branch}
                          isManagerPermission={false}
                        />
                      )}
                      {/* 姓 */}
                      <FormEle.LastName
                        validate={validate.name_sei}
                        id='name_sei'
                        defaultValue={params.name_sei}
                      />
                      {/* 名 */}
                      <FormEle.FirstName
                        validate={validate.name_mei}
                        id='name_mei'
                        defaultValue={params.name_mei}
                      />
                      {/* せい */}
                      <FormEle.LastNameKana
                        validate={validate.kana_sei}
                        id='kana_sei'
                        defaultValue={params.kana_sei}
                      />
                      {/* めい */}
                      <FormEle.FirstNameKana
                        validate={validate.kana_mei}
                        id='kana_mei'
                        defaultValue={params.kana_mei}
                      />
                      {/* 電話番号 */}
                      <FormEle.Tel
                        validate={validate.tel}
                        id='tel'
                        defaultValue={params.tel}
                      />
                      <SwitchForm show={this.roleId === USER_ROLES.partner.id}>
                        {/* FAX */}
                        <FormEle.Fax
                          validate={validate.fax}
                          id='fax'
                          defaultValue={params.fax}
                        />
                      </SwitchForm>
                      {/* ログインユーザーが元請ユーザー、または協力会社管理者の場合のみ表示される項目 */}
                      <SwitchForm
                        show={
                          isPrimaryCompanyRoleId(this.roleId) ||
                          isTargetRoleId([USER_ROLES.partner], this.roleId)
                        }
                      >
                        <FormEle.Email
                          validate={validate.email}
                          id='email'
                          defaultValue={params.email}
                        />
                      </SwitchForm>
                      {/* ログインユーザーが職長の場合のみ表示される項目。 */}
                      <SwitchForm show={this.roleId === USER_ROLES.foreman.id}>
                        <FormEle.UserId
                          validate={validate.login_id}
                          id='login_id'
                          defaultValue={_.get(params, 'session.login_id')}
                        />
                      </SwitchForm>
                      {isSamlUser === 'false' && (
                        <React.Fragment>
                          {/* パスワードラベル */}
                          <FormListItem
                            label='パスワード'
                            className='form-list__item form-list__item--open'
                          />
                          {/* 現在のパスワード */}
                          {this.state.privatePasswordPolicy
                            .policy_description && (
                            <FormListItem
                              label=' '
                              className='form-list__item form-list__item--child form-list__item--child-password'
                            >
                              <FormElement>
                                ※
                                {
                                  this.state.privatePasswordPolicy
                                    .policy_description
                                }
                              </FormElement>
                            </FormListItem>
                          )}
                          <FormEle.CurrentPassword
                            validate={validate.current_password}
                            id='current_password'
                            EventMg={this.FormEventMg}
                          />
                          {/* パスワード */}
                          <FormEle.Password
                            validate={validate.password}
                            id='password'
                            EventMg={this.FormEventMg}
                          />
                          {/* パスワード確認 */}
                          <FormEle.PasswordConf
                            validate={validate.password_confirmation}
                            id='password_confirmation'
                            EventMg={this.FormEventMg}
                          />
                        </React.Fragment>
                      )}
                      {/* ログインユーザーが職長の場合のみ表示される項目。 */}
                      <SwitchForm show={this.roleId === USER_ROLES.foreman.id}>
                        <FormEle.SubEmail
                          validate={validate.email}
                          id='email'
                          defaultValue={params.email}
                        />
                      </SwitchForm>
                      {/* 画像ファイルアイコン & アップロード */}
                      <FormEle.IconForm
                        validate={validate.user_image}
                        id='user_image'
                        defaultValue={imageURL}
                        image={params.image}
                      />
                    </Form>
                  </FormList>
                </div>
                <Modal modalRoot='root' modalState={this.state.showModal}>
                  <DialogSuccessError
                    msg={this.state.updateMsg}
                    msgDetail={this.state.updateMsgDetail}
                    updateSuccess={this.state.updateSuccess}
                    success={() => {
                      this.setState({ showModal: false });
                      // 遷移
                      this.props.history.push('/');
                    }}
                    error={() => this.setState({ showModal: false })}
                    labelBtnError={messageUtility.getMessage('I-000-017')}
                    multilineText={true}
                  />
                </Modal>

                {/* 警告メッセージ */}
                <Confirmation
                  visible={this.state.visibleConfirmation}
                  title='ユーザーID（メールアドレス）の変更'
                  message={INTEGRATE_USER_CHANGE_EMAIL_CONFIRM_MESSAGE}
                  onConfirm={this.state.confirm}
                  onCancel={() => this.handleVisibleDialog(false)}
                  multilineText={true}
                  confirmButtonText='更新'
                  cancelButtonText='戻る'
                />
                <ConfirmExistedEmailDialog
                  visible={this.state.visibleEmailExistedConfirmation}
                  onCancel={() =>
                    this.toggleDialog('visibleEmailExistedConfirmation', false)
                  }
                  onConfirmNotIntegrate={
                    this.confirmExistedEmailIgnoreIntegrate
                  }
                  onConfirmIntegrate={this.confirmExistedEmailIntegrate}
                  userRoleCode={this.roleId}
                />
                <ConfirmIntegrateUserDialog
                  visible={this.state.visibleIntegrateConfirmation}
                  onConfirm={this.integrateConfirm}
                  onCancel={() =>
                    this.toggleDialog('visibleIntegrateConfirmation', false)
                  }
                  data={this.state.integrateUsers}
                />
                <IntegrateError
                  visible={this.state.visibleIntegrateError}
                  reason={this.state.reasonIntegrateError}
                  userRoleCode={this.roleId}
                  onConfirm={this.integrateErrorConfirm}
                  onCancel={() =>
                    this.toggleDialog('visibleIntegrateError', false)
                  }
                />
                <Information
                  visible={this.state.visiblePopupCommonError}
                  title={messageUtility.getMessage('E-001-402')}
                  message={INTEGRATE_USER_COMMON_ERROR_MESSAGE}
                  buttonText={messageUtility.getMessage('I-000-017')}
                  onClose={() =>
                    this.toggleDialog('visiblePopupCommonError', false)
                  }
                  multilineText={true}
                />
                <LogoutUserIntegrateModal
                  visible={this.state.visibleLogoutUser}
                />
                <ConfirmChangeIntegratedEmailDialog
                  visible={this.state.visibleChangeIntegratedEmail}
                  onConfirm={this.confirmChangeIntegratedEmail}
                  onCancel={() =>
                    this.toggleDialog('visibleChangeIntegratedEmail', false)
                  }
                  data={this.state.integrateUsers}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * @description 一番上のヘッダー
 */
const FormTopHeader = ({ logoutButton }) => (
  <MasterPageHeader
    title='アカウント詳細・編集'
    rightComponent={logoutButton}
  />
);

// イベントを受け取るのでここは React.Component にする
class FormViewMenu extends React.Component {
  constructor(props) {
    super(props);

    const { required, EventMg } = this.props;
    this.state = { required };
    this.EventMg = EventMg;
  }

  componentDidMount() {
    // フォームの変化のイベント取得
    this.EventMg.addEventListener('change_value', (...args) => {
      // 0番目は今回編集したのが入る
      if (!args[0]) {
        // 空文字のとき
        return;
      }
      const { scheme, required, validateMessageUpdate } = this.props;
      const params = args[1];
      const result = runExtendJoi(scheme, _.cloneDeep(params));
      const filteredRequired = _.cloneDeep(required);
      // 必須項目処理
      _.each(required, (v, key) => {
        filteredRequired[key] =
          key === 'partner_company_branch' || !!params[key];
      });
      if (!_.isEqual(required, filteredRequired)) {
        this.setState({ required: filteredRequired });
      }
      if (validateMessageUpdate) {
        // フォームの下にバリデーションのエラーメッセージを出す
        validateMessageUpdate(result);
      }
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      _.difference(_.keys(nextProps.required), _.keys(this.props.required))
        .length
    ) {
      let required = _.cloneDeep(nextProps.required);
      _.each(this.state.required, (value, key) => {
        required[key] = value;
      });
      this.setState({ required });
    }
  }

  render() {
    // パスワードの入力量が残るので該当キーだけピックアップする
    const result = _.pick(this.state.required, _.keys(this.props.required));
    const validateResult = _.omit(result, _.keys(this.props.validate));
    const counter = _.size(_.filter(validateResult));
    const total = _.size(this.props.required);

    return (
      <div className='contruction-detail-view__menu'>
        <span className='construction-detail-view__button'>
          <button
            className='btn--effective'
            onClick={() => this.EventMg.trigger('submit')}
          >
            更新
          </button>
        </span>
        <div className='contruction-detail-view__end-item'>
          {`必須項目の入力数 ${counter}/${total}`}
        </div>
      </div>
    );
  }
}
export default withRouter(InvitedUserProfileForm);



// WEBPACK FOOTER //
// ./src/pages/InvitedUserProfileForm.jsx